export default "__VITE_ASSET__9mzyohoV__"